import React from "react";

const Spacer3 = ({ size }) => {
  return <div style={{ height: `${size || 58}px` }}></div>;
};

export default Spacer3;

//! Spacer in görevi Customer Service yazısı gibi section title için boşluk bırakır....
